export default __webpack_public_path__ + "assets/735cdd895909f6f5317acf49bcc12b1d.jpg";